import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CountingDocument } from '@raptor-fe/core';
import { ServiceUtils } from '../service-utils/service-utils';

@Injectable({
    providedIn: 'root',
})
export class CountingDocumentService {
    private readonly http = inject(HttpClient);
    private readonly serviceUtils = inject(ServiceUtils);

    save(tenantId: string, branchId: string, countingDocument: CountingDocument): Observable<CountingDocument> {
        if (!countingDocument.id || countingDocument.id === null)
            return this.http.post<CountingDocument>(`${this.serviceUtils.getBaseUrl('countingDocument', tenantId, branchId)}`, countingDocument);
        else return this.http.put<CountingDocument>(`${this.serviceUtils.getBaseUrl('countingDocument', tenantId, branchId)}`, countingDocument);
    }

    reset(tenantId: string, branchId: string, countingDocumentId: string): Observable<CountingDocument> {
        return this.http.put<CountingDocument>(`${this.serviceUtils.getBaseUrl('countingDocument', tenantId, branchId)}/reset/${countingDocumentId}`, {});
    }
}
